import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ThemeProvider } from './context/ThemeContext';
import NotificationProvider from './context/NotificationContext'; // правильный импорт
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CalendarPage from './pages/CalendarPage';
import VehiclesPage from './pages/VehiclesPage';
import WorkOrdersList from './pages/WorkOrdersList';
import WorkOrderForm from './pages/WorkOrderForm';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import ClientsPage from './pages/ClientsPage';
import DevicesPage from './pages/DevicesPage';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import WorkOrderFormPage from './pages/WorkOrderFormPage';
import LogsPage from './pages/LogsPage';

const queryClient = new QueryClient();

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <NotificationProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/calendar" element={<PrivateRoute><CalendarPage /></PrivateRoute>} />
                <Route path="/vehicles" element={<PrivateRoute><VehiclesPage /></PrivateRoute>} />
                <Route path="/workorders" element={<PrivateRoute><WorkOrdersList /></PrivateRoute>} />
                <Route path="/workorder/new" element={<PrivateRoute><WorkOrderFormPage /></PrivateRoute>} />
                <Route path="/workorder/edit/:id" element={<PrivateRoute><WorkOrderFormPage /></PrivateRoute>} />
                <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
                <Route path="/clients" element={<PrivateRoute><ClientsPage /></PrivateRoute>} />
                <Route path="/devices" element={<PrivateRoute><DevicesPage /></PrivateRoute>} />
                <Route path="/users" element={<PrivateRoute allowedRoles={['admin']}><UsersPage /></PrivateRoute>} />
                <Route path="/roles" element={<PrivateRoute allowedRoles={['admin']}><RolesPage /></PrivateRoute>} />
                <Route path="/logs" element={<PrivateRoute><LogsPage /></PrivateRoute>} />
              </Routes>
            </Router>
          </NotificationProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;